import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";

const firebaseConfig = {
    "apiKey": "AIzaSyC0EeYEz6RcXogSKMzGXNqLbN_JUWp1iYA",
    "appId": "1:1001698473625:web:f04ffb3ba64cd8720b6a08",
    "authDomain": "connectinchat.firebaseapp.com",
    "databaseURL": "",
    "measurementId": "G-86DBDW9R4M",
    "messagingSenderId": "1001698473625",
    "projectId": "connectinchat",
    "storageBucket": "connectinchat.appspot.com"
  };
  const firebaseApp = firebase.initializeApp(firebaseConfig);
  const auth = firebase.auth();
  const firestore = firebaseApp.firestore();
  
  export { auth, firestore };
  